var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"group-row"},[_c('td'),_c('td',[_c('v-icon',{on:{"click":function($event){return _vm.$emit('toggle')}}},[_vm._v(_vm._s(_vm.expanded ? "mdi-minus" : "mdi-plus"))])],1),_c('td',{staticClass:"name-column",attrs:{"colspan":"10"}},[_vm._v(" "+_vm._s(_vm.isUngrouped ? "Ungrouped" : _vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }